import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import Skills from "./views/Skills.vue";
import Achievements from "./views/Achievements.vue";
import About from "./views/About.vue";
import Contact from "./views/Contact.vue";
import PageNotFound from "./views/PageNotFound.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Home
    },
    {
      path: "/skills",
      component: Skills
    },
    {
      path: "/achievements",
      component: Achievements
    },
    {
      path: "/about",
      component: About
    },
    {
      path: "/contact",
      component: Contact
    },
    {
      path: "*",
      component: PageNotFound
    }
  ]
});
